<template>
    <div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">תצוגה מקדימה לשאלה {{ id }}</p>
                <button type="button" class="delete" @click="$emit('close')" />
            </header>
            <section class="modal-card-body">
                <div class="date-list">
                    <button
                        v-for="(item, idx) in model"
                        :key="idx"
                        class="date-item"
                        :class="{ 'is-active': idx === selectedIdx }"
                        @click="selectedIdx = idx"
                    >
                        {{ parseDate(item.archiveDate) }}
                    </button>
                </div>
                <div class="Loading">
                    <template v-if="selected">
                        <p v-if="selected.modifiedByUserName" class="modified-by">
                            עודכן על ידי: <span>{{ selected.modifiedByUserName }}</span>
                        </p>
                        <div v-html="selected.question"></div>
                        <div class="question-answers">
                            <div v-for="(answer, idx) in selected.answers" :key="idx" class="question-answer">
                                <input :checked="answer.isCorrectAnswer" type="radio" name="" id="">
                                <label v-html="answer.answer" for="question1"></label>
                            </div>
                        </div>
                        <b-field label="תשובה מפורטת">
                            <div v-html="selected.detailedAnswer"></div>
                        </b-field>
                    </template>
                    <div v-else class="empty-state">אין היסטוריה לשאלה זו</div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <b-button :disabled="isLoading" label="סגור" @click="$emit('close')" />
            </footer>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import LessonService from "../services/LessonService";

export default {
    name: "DialogQuestionPreview",
    props: ["id", "store"],
    components: {
    },
    computed: {
        questionId() {
            return this.store.state.question?.id;
        },
        selected() {
            return this.model[this.selectedIdx] || null;
        },
    },
    created() {
        this.getQuestionHistory();
    },
    data() {
        return {
            submitted: false,
            isLoading: false,
            model: [],
            selectedIdx: 0,
        };
    },
    methods: {
        parseDate(date) {
            return moment(date).format("DD/MM/YYYY HH:mm");
        },
        getQuestionHistory() {
            this.isLoading = true;
            LessonService.getQuestionHistory(this.id)
                .then((r) => {
                    this.model = r.data;
                    this.selectedIdx = 0;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>

<style scoped lang="scss">
.question-answers {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
    margin: 10px 0;
    pointer-events: none;
}

.question-answer {
    display: flex;
    align-items: center;
    gap: 5px;
}

.Loading {
    overflow: auto;
    max-height: 600px;
    // pointer-events: none;

    ::v-deep ol {
        list-style-type: decimal;
        margin: revert;
        padding: revert;
    }

    ::v-deep ol ol {
        list-style-type: lower-alpha;
    }

    ::v-deep ol ol ol {
        list-style-type: lower-roman;
    }

    ::v-deep ul {
        list-style-type: disc;
        margin: revert;
        padding: revert;
    }
}
.modal-card-body {
    display: flex;
    gap: 20px;
}

.date-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    border-inline-end: 1px solid #e0e0e0;
    padding-inline-end: 15px;
}

.date-item {
    display: block;
    width: 100%;
    text-align: start;
    padding: 8px 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
    font-size: 13px;
    transition: background 0.15s, border-color 0.15s;

    &:hover {
        background: #f2f2f2;
    }

    &.is-active {
        background: #1E9EB8;
        border-color: #1E9EB8;
        color: #fff;
    }
}

.Loading:not(.side-menu) {
    flex: 1 1 auto;
}

.empty-state {
    color: #666;
    padding: 20px 0;
}

.modified-by {
    color: #666;
    font-size: 13px;
    margin-bottom: 10px;

    span {
        font-weight: bold;
        color: #333;
    }
}
</style>
